define('gigaset_csp/components/product/register',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"select2",
	"picker-date",
	"bootstrap-button"
], function(
	$,
	Component,
	BEM,
	S2
) {
	return Component.create({
		block: null,

		form:				null,
		varienForm:			null,
		submitButton:		null,
		producttypeSelect:	null,
		productSelect:		null,
		dateofpurchase:		null,

		options:			null,

		loading:			false,

		$init: function() {
			this.block = BEM.block("csp-product-register-form");
			this.form = this.block.getElements("form");
			this.submitButton = this.block.getElements("submit-button");
			this.varienForm = new VarienForm(this.form.get(0));

			this.options = this.block.data("config");

			this.producttypeSelect = this.block.getElements("producttype");

			this.producttypeSelect
				.select2()
				.on("change", $.proxy(this._onChangeProducttype, this));

			this.productSelect = this.block.getElements("product");
			this.productSelect.select2();

			this.dateofpurchase = this.block.getElements("dateofpurchase");
			this.dateofpurchase.pickadate({
				formatSubmit: 'yyyy/mm/dd'
			});

			this.form.on("submit", $.proxy(this._onFormSubmit, this));
		},

		setLoading: function(flag) {
			this.loading = flag;
			this.block[flag ? "addModifier" : "removeModifier"]("loading");
		},

		_onChangeProducttype: function() {
			var self = this,
				producttype = this.producttypeSelect.val();

			if (producttype.length === 0) {
				this._onProductsRetrieve({});
				return;
			}

			this.setLoading(true);
			this.productSelect.attr("disabled", "disabled");
			this.productSelect.html("");

			$
				.ajax(this.options.productOptionsUrl, {
					method: "GET",
					data: {
						producttype: producttype
					}
				})
				.done($.proxy(this._onProductsRetrieve, this))
				.always(function() {
					self.setLoading(false);
				});
		},

		_onProductsRetrieve: function(data) {
			var optionsHtml = [];

			$.each(data, function(key, value) {
				optionsHtml.push('<option value="' + key + '">' + value + '</option>');
			});

			this.productSelect.html(optionsHtml.join(""));

			if (optionsHtml.length) {
				this.productSelect.removeAttr("disabled");
			} else {
				this.productSelect.attr("disabled", "disabled");
			}

			this.productSelect.select2();
		},

		_onFormSubmit: function(e) {
			if (this.loading || !this.varienForm.validator.validate()) {
				e.preventDefault();
				return;
			}

			this.block.addModifier("submitting");
			this.submitButton.button("loading");
		}
	});
});
